var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTooltip)?_c('div',{ref:"tooltip",staticClass:"mkvue-directive-tooltip"},[_c('div',{staticClass:"mkvue-directive-tooltip-inner"},[_vm._v(" "+_vm._s(_vm.content)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }